import {
  AxiosStatic,
  InternalAxiosRequestConfig,
} from 'axios'

/**
 * Decorate authentication headers to outgoing requests
 * @param condition If the predicate evaluates to true, attach the token
 * @param token Getter for the authentication headers value
 */
// eslint-disable-next-line import/prefer-default-export
export function attachAuthenticationTokenToRequests(
  axios: AxiosStatic,
  token: () => Promise<string>,
  condition: (requestConfig: InternalAxiosRequestConfig) => boolean = () => true,
) {
  axios.interceptors.request.use(
    async (request: InternalAxiosRequestConfig) => {
      if (!request.flags?.disableBearerAuthentication && condition(request)) {
      // eslint-disable-next-line no-param-reassign
        request.headers.Authorization = await token()
      }
      return request
    },
    (err) => Promise.reject(err.response),
  )
}
